<template>
  <div v-if="!uploading && sections!=null">
    <sctn v-if="selectedSection !== null && !redrawing" :section="sections[selectedSection]" :sections="sections" :index="selectedSection"></sctn>
    <layers class="layer-controls layer-draggable" :layers="dirs" :z="z.active + 100" draggerclass="layer-drag-icon">
      <div :class="s.shared ? 'section-row shared-section-row' : 'section-row'" v-for="(s, i) in sections" :key="'depth_layer_' + i.toString()" :slot="'slot' + i.toString()">
        <label>
          <span>{{dirs[i]}}</span>
          <!-- <input type="text" v-model="sections[i].title"> -->
          <button v-on:click="selectedSection = i">Edit</button>
          <button v-on:click="deleteSection(i)">Delete</button>
        </label>
      </div>
    </layers>
    <!-- <button class="output-button" v-on:click="output()">Output</button> -->
    <label class="mobile-state-toggle">Mobile View <input type="checkbox" v-on:change="onMobleEditorStateChange" /></label>
    <button class="add-section-button" v-on:click="addSection()">Add Section</button>
    <div class="start-nav" v-if="sections.length == 0">
      <label>Upload Zip File <input type="file" name="file" :id="fileInputID" /></label>
      <button v-if="zipSrc != null" v-on:click="uploadZip">Upload</button>
    </div>
    <mwin v-if="addData.adding" :sig="addData.addSig" :cancelable="true">
      <div slot="content">
        <label><input type="checkbox" v-model="addData.useExisting" /> Select from exsisting folders</label>
        <div v-if="addData.useExisting">
          <select v-if="allSlideFolders != null" v-model="addData.existingID">
            <option value="none">
              Please Select a Slide
            </option>
            <option v-if="slideIsAvailable(f)" v-for="(f, i) in allSlideFolders" :key="'slidef_' + i.toString()" :value="f">
              {{f}}
            </option>
          </select>
        </div>
        <div v-else>
          <input type="text" placeholder="section id" v-model="addData.id" />
          <input type="text" placeholder="section title" v-model="addData.title" />
          <label><input type="checkbox" v-model="addData.shared"> Shared</label>
        </div>
      </div>
    </mwin>
    <mwin v-if="addData.deleting" :sig="addData.deleteSig" :cancelable="true">
      <div slot="content">
        Are you sure you want to delete this section?
      </div>
    </mwin>
  </div>
  <div class="loading-bar" v-else></div>
</template>

<script>
import {EventBus} from './utils/EventBus.js'
import LayerList from './editors/LayerList.vue'
import Section from './editors/Section.vue'
import Sections from './utils/Sections.js'
import WidgetUtils from './utils/WidgetUtils.js'
import GeneralUtils from './utils/GeneralUtils.js'
import TemplateUtils from './utils/templates/TemplateUtils.js'
import Block from './utils/templates/Block.js'
import Image from './utils/templates/Image.js'
import Text from './utils/templates/Text.js'
import JSApp from './utils/templates/JSApp.js'
import IFrame from './utils/templates/IFrame.js'
import SectionTemplate from './utils/templates/SectionTemplate.js'
import ModalWindow from './editors/ModalWindow.vue'
import axios from 'axios'
// import WidgetUtils from './components/utils/WidgetUtils.js'
export default {
  props: ['dirs'],
  components: {
    layers: LayerList,
    sctn: Section,
    mwin: ModalWindow
  },
  name: 'app',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      redrawing: false,
      sections: null,
      z: {
        active: 2000,
        inactive: 1
      },
      selectedSection: null,
      addData: {
        adding: false,
        deleting: false,
        title: '',
        id: '',
        addSig: GeneralUtils.Modals.ADD_SECTION,
        deleteSig: GeneralUtils.Modals.DELETE_SECTION,
        deleteIndex: -1,
        useExisting: true,
        existingID: 'none',
        shared: false
      },
      allSlideFolders: null,
      dirMatrix: {},
      fileInputID: 'target_file_input',
      projectName: '',
      zipSrc: null,
      uploading: false
    }
  },
  methods: {
    onMobleEditorStateChange: function (e) {
      var self = this
      var isChecked = e.currentTarget.checked
      document.querySelector('#editormobileemulator').innerHTML = isChecked.toString()
      self.$data.redrawing = true
      setTimeout(function () {self.$data.redrawing = false}, 100)
    },
    output: function () {
      var self = this
      console.log(JSON.stringify(self.$data.sections))
    },
    addSection: function () {
      var self = this
      self.$data.addData.adding = true
      self.$data.allSlideFolders = null
      Sections.getAllSlideFolders((d) => {
        self.$data.allSlideFolders = d
      }, (err) => {
        console.log(err)
      })
      // need to create folder for section
      // self.$data.sections.push(JSON.parse(JSON.stringify(SectionTemplate)))
    },
    slideIsAvailable: function (s) {
      var self = this
      var available = true
      for (var i = 0; i < self.dirs.length; i++) {
        if (s === self.dirs[i]) {
          available = false
        }
      }
      return available
    },
    deleteSection: function (index) {
      var self = this
      self.$data.addData.deleting = true
      self.$data.addData.deleteIndex = index
    },
    onSectionConfigChange: function () {
      EventBus.$emit('section-config-change', {})
    },
    onFileInputChange: function () {
      var self = this
      var file = document.getElementById(self.$data.fileInputID).files[0]
      self.$data.zipSrc = null
      if (file) {
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.addEventListener('load', function () {
          // console.log(reader)
          self.$data.zipSrc = reader.result
        })
      }
    },
    uploadZip: function () {
      var self = this
      var projectID = 'p_' + Math.random().toString().split('.').join('') + Math.random().toString().split('.').join('') + Math.random().toString().split('.').join('')
      self.$data.uploading = true
      // var preview = document.getElementById(self.$data.ids.uploadPreview)
      axios.post(GeneralUtils.getBaseURL() + 'editor/upload_file', {project_id: projectID, file: self.$data.zipSrc}).then((response) => {
        // console.log('upload complete!!!!!!!!!!!!!!!!!')
        // self.$data.selectedProject = projectID
        // self.loadProjectDirectoyList()
        self.$data.zipSrc = null
        self.$data.projectName = ''
        // self.loadSections()
        // self.$data.uploading = false
        location.reload()
        // console.log(response)
      }).catch((err) => {
        self.$data.uploading = false
        alert(err)
      })
    },
    mapUploadListener: function () {
      var self = this
      if (document.getElementById(self.$data.fileInputID)) {
        document.getElementById(self.$data.fileInputID).addEventListener('change', self.onFileInputChange)
      } else {
        setTimeout(self.mapUploadListener, 500)
      }
    },
    loadSections: function () {
      var self = this
      Sections.getSectionsByList(
        self.dirs,
        (d) => {
          // console.log(d)
          for (var i = 0; i < self.dirs.length; i++) {
            self.$data.dirMatrix[self.dirs[i]] = d[i].shared
            // self.$data.dirMatrix.push({name: self.dirs[i], shared: d[i]})
          }
          console.log(self.$data.dirMatrix)
          self.$data.sections = d
          // for (var i = 0; i < self.$data.sections.length; i++) {
          //   self.setInnerStyles(self.$data.sections[i].shared, i)
          //   // self.$data.innerStyles[i] = self.getInnerStyle(self.$data.sections[i].shared)
          // }
          // window.addEventListener('scroll', self.pageScrolled)
          // self.pageScrolled()
        },
        (err) => {
          console.log(err)
        }
      )
    }
  },
  mounted: function () {
    var self = this
    EventBus.$on('layer-reposition-event', (n) => {
      console.log(n)
      var nList = []
      for (var i = 0; i < n.length; i++) {
        if (!self.$data.dirMatrix[n[i]]) {
          nList.push(n[i])
        }
      }
      for (i = 0; i < n.length; i++) {
        if (self.$data.dirMatrix[n[i]]) {
          nList.push(n[i])
        }
      }
      console.log(nList)
      Sections.arangeSections(
        nList,
        function (d) {
          self.onSectionConfigChange()
        },
        function (err) {
          console.log(err)
        }
      )
      // var keyList = n
      // for (var i = 0; i < keyList.length; i++) {
      //   self.$data.bounds[keyList[i]].depth = i
      // }
      // self.$data.avatarResources.depthOrder = n
    })
    EventBus.$on('section-save', (n) => {
      Sections.saveSection(
        n.section,
        self.dirs[n.index],
        (d) => {
          console.log(d)
        },
        (err) => {
          console.log(err)
        }
      )
      Sections.saveSharedSections(
        self.$data.sections,
        self.dirs,
        (n) => {
          console.log(n)
        },
        (err) => {
          console.log(err)
        }
      )
    })
    EventBus.$on('section-widget-added', (n) => {
      var addedWidget = null
      switch (n.type) {
        case WidgetUtils.WidgetTypes.BLOCK:
        {
          addedWidget = Block
          break
        }
        case WidgetUtils.WidgetTypes.TEXT:
        {
          addedWidget = Text
          break
        }
        case WidgetUtils.WidgetTypes.JS_APP:
        {
          addedWidget = JSApp
          break
        }
        case WidgetUtils.WidgetTypes.IMAGE:
        {
          addedWidget = Image
          break
        }
        case WidgetUtils.WidgetTypes.IFRAME:
        {
          addedWidget = IFrame
          break
        }
      }
      console.log(addedWidget)
      var newWidgetData = JSON.parse(JSON.stringify(addedWidget))
      if (self.$data.sections[n.index].shared) {
        var transitionList = TemplateUtils.getTransition(Sections.getNonSharedSections(self.$data.sections).length)
        newWidgetData.transition = transitionList
        // create transition list for shared widgets
      }
      self.$data.sections[n.index].widgets.push(newWidgetData)
    })
    EventBus.$on('modal-window-cancel', (n) => {
      self.$data.addData.adding = false
      self.$data.addData.deleting = false
      self.$data.addData.shared = false
    })
    EventBus.$on('modal-window-ok', (n) => {
      switch (n.sig) {
        case self.$data.addData.addSig:
        {
          if (self.$data.addData.useExisting) {
            Sections.addSectionToList(
              self.$data.addData.existingID,
              Sections.getNonSharedSections(self.$data.sections).length,
              (d) => {
                self.$data.addData.adding = false
                console.log('before -----------------------------')
                console.log(d)
                Sections.remapSharedSections(self.$data.sections)
                // console.log('after -----------------------------')
                // console.log(self.$data.sections)
                Sections.saveSharedSections(
                  self.$data.sections,
                  self.dirs,
                  (n) => {
                    console.log(n)
                    self.onSectionConfigChange()
                  },
                  (err) => {
                    console.log(err)
                  }
                )
                // Sections.arangeSections(
                //   nList,
                //   function (d) {
                //     Sections.saveSharedSections(
                //       self.$data.sections,
                //       self.dirs,
                //       (n) => {
                //         console.log(n)
                //         self.onSectionConfigChange()
                //       },
                //       (err) => {
                //         console.log(err)
                //       }
                //     )
                //   },
                //   function (err) {
                //     console.log(err)
                //   }
                // )
              },
              (err) => {
                console.log(err)
              }
            )
          } else {
            var templateObject = JSON.parse(JSON.stringify(SectionTemplate))
            templateObject.shared = self.$data.addData.shared
            templateObject.title = self.$data.addData.title
            Sections.addSection(
              self.$data.addData.id,
              templateObject,
              Sections.getNonSharedSections(self.$data.sections).length,
              (d) => {
                self.$data.addData.adding = false
                Sections.remapSharedSections(self.$data.sections)
                Sections.saveSharedSections(
                  self.$data.sections,
                  self.dirs,
                  (n) => {
                    console.log(n)
                    self.onSectionConfigChange()
                  },
                  (err) => {
                    console.log(err)
                  }
                )
                console.log(d)
              },
              (err) => {
                console.log(err)
              }
            )
          }
          break
        }
        case self.$data.addData.deleteSig:
        {
          Sections.removeSection(
            self.dirs[self.$data.addData.deleteIndex],
            (d) => {
              self.$data.addData.deleting = false
              console.log(d)
              Sections.remapSharedSections(self.$data.sections, self.$data.addData.deleteIndex)
              Sections.saveSharedSections(
                self.$data.sections,
                self.dirs,
                (n) => {
                  console.log(n)
                  self.onSectionConfigChange()
                },
                (err) => {
                  console.log(err)
                }
              )
            },
            (err) => {
              console.log(err)
            }
          )
          break
        }
      }
      self.$data.addData.shared = false
    })
    self.loadSections()
    self.mapUploadListener()
    // self.loadProjectDirectoyList()
  }
}
</script>

<style lang="scss">
ul.layer-controls{
  position:fixed;
  top:0;
  left:0;
  bottom:40px;
  overflow-y: auto;
  width:250px;
  height: auto !important;
  display: inline-block;
  > li{
    > div{
      > div{
        > label{
          display:block;
          > input[type='text']{
            display:block;
          }
        }
      }
    }
  }
  
}
button.output-button{
  position: fixed;
  top:0;
  left: 0;
  z-index:20000;
}
button.add-section-button{
  position: fixed;
  bottom: 4px;
  left: 4px;;
  z-index:2000;
}
label.mobile-state-toggle{
  position: fixed;
  bottom: 4px;
  left: 120px;;
  z-index:2000;
}
div.section-row{

}
div.shared-section-row{

}
div.start-nav{
  width: 300px;
  height: 180px;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -150px;
  margin-top: -90px;
  > button{
    width: 100%;
  }
}
</style>
<style>
.layer-drag-icon{
  width:20px;
  height: 20px;
  background-color: #00cccc;
}

</style>




// WEBPACK FOOTER //
// src/components/EditorView.vue